import { render, staticRenderFns } from "./groupRobot.vue?vue&type=template&id=794e31d2&"
import script from "./groupRobot.vue?vue&type=script&lang=ts&"
export * from "./groupRobot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports